import { styled } from "@linaria/react";
import { color } from "..";

export const StyledScrollbarDiv = () => {
  if (window.navigator.appVersion.includes("Mac")) return styled.div``;
  return styled.div`
    /* firefox */
    & {
      --scrollbar-color: ${color.titanium600};
      scrollbar-color: var(--scrollbar-color) transparent;
      scrollbar-width: thin;
    }

    /* chrome */
    &::-webkit-scrollbar {
      width: 7px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${color.titanium500};
      border-radius: 20px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${color.titanium600};
    }
  `;
};
